import { fetchGet } from './fetch'

export const getWorkOrders = async customerId => {
  const url = `/api/work-orders/${encodeURIComponent(customerId)}`
  return await fetchGet(url)
}
